// @flow
import _set from 'lodash/set';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getUserData } from '../../redux/modules/user';
import isEqual from 'react-fast-compare';

const mapStateToProps = state => {
    const userData = getUserData(state) || {};
    return {
        ANMS: 0,
        bidderId: 0,
        ...userData,
    };
};

type Props = {
    ANMS: number,
    bidderId: number,
};

export class SoastaGlobalSetter extends Component<Props> {
    componentDidMount() {
        this.setSoasta(this.props);
    }

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    componentDidUpdate() {
        this.setSoasta(this.props);
    }

    setSoasta = (props: Props) => {
        if (typeof window !== 'undefined') {
            // SSR doesn't use window
            const { ANMS, bidderId } = props;
            const highANMS = ANMS > 4500 ? 1 : 0;
            _set(window, 'soasta.user', { ANMS, bidderId, highANMS });
            _set(window, 'BOOMR.xhr_excludes', {
                'api.sail-track.com': true,
                'api.segment.com': true,
                'c.go-mpulse.net': true,
                'c.riskified.com': true,
                'doubleclick.net': true,
                'r.fullstory.com': true,
                'sumo.com': true,
                'www.youtube.com': true,
            });
        }
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps)(SoastaGlobalSetter);
